import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  width: 100%;
  padding: 30px 20px 0 20px;
`;
